<template>
  <div class="full-container " @resize="pageResize">
    <div class="full-container ">
      <div class="container " style="padding-top: 50px; padding-bottom:50px; padding-left:0;padding-right:0; max-width: 1200px;">
        <div class="title">福利体系</div>
        <div class="content">对员工的尊重首要反映在对员工劳动价值的尊重。为了吸引、激励和保留优秀人才，实现企业与员工的双赢，公司突出了以技能为主体，以技能定薪，能岗匹配，岗变薪变，重在考核的原则，为员工提供全面的、有竞争力的薪酬福利体系</div>
      </div>
    </div>

    <div class="container welfare-container ">
      <div class="welfare-list">
        <div class="welfare-item">
          <div class="welfare-title">福利原则 01</div>
          <div class="welfare-desc pi-lh-30">在福利政策设计和执行过程中，将确保公开公正的透明性原则、确保员工都可享受福利项目的平等性原则、确保根据不同职级或岗位的差异性原则、确保基于公司业绩和内外部环境变化而不同的可增减性原则。</div>
        </div>
        <div class="welfare-item">
          <div class="welfare-title">福利原则 02</div>
          <div class="welfare-desc">公司福利设计的整体原则需要注重员工的个人与家庭、关注员工的健康与安全，为员工提供有效的生活保障。</div>
        </div>
      </div>
      <el-image class="welfare-tree" :src="treeImg"></el-image>
    </div>

    <div class="container ">
      <el-image :src="envImg"></el-image>
    </div>

    <div class="container ">
      <div class="container " style="padding-top: 50px; padding-bottom:50px; ">
        <div class="title">人才体系</div>
      </div>
      <div class="personnel-container">
        <div
          class="personnel-item"
          v-for="(item, index) in personnelList"
          :key="'personnel' + index"
          >
          <i class="iconfont" :class="item.icon"></i>
          <span class="personnel-title pi-fz-20">{{item.name}}</span>
          <span class="personnel-desc pi-fz-14">{{item.desc}}</span>
        </div>
      </div>
    </div>

    <div class="container ">
      <el-image :src="channelImg"></el-image>
    </div>

    <div class="container" style="padding-top: 50px; padding-bottom:20px; max-width: 1200px;">
      <div class="title">欢迎优秀的你加入我们!</div>
    </div>
    <div class="container ">
      <div class="recruit-container">
        <div class="rec-title">最新岗位</div>
        <div class="rec-positions">
          <div
            class="rec-position"
            v-for="(item, index) in recruitPositions"
            :key="'position-list' + index"
            >
            <span
              v-for="(subItem, subIndex) in item"
              :key="'position-list' + subIndex"
              class="rec-position-item"
              >
              <span v-if="subIndex != 0 && subIndex != 5" class="rec-feacture-name" >|</span>
              <span class="rec-feacture-title">{{subItem}}</span>
            </span>
          </div>
        </div>
        <div class="rec-feactures">
          <span
            v-for="(item, index) in recruitFeature"
            :key="'recruitFeature' + index"
            class="rec-feacture"
            >
            <span class="rec-feacture-name">{{item.name}}</span>
            <span class="rec-feacture-title">{{item.title}}</span>
          </span>
        </div>
        <div class="to-recruit-button" @click="toEmail">
            <span>立即投递简历</span>
            <i class="iconfont iconweibiaoti40"></i>
          </div>
      </div>
    </div>

  </div>
</template>

<script>
import data from './data.js'
import {slicingArray} from '@/utils'
export default {
  name: "product",
  data() {
    return {
      treeImg: require('@/assets/site/skill_tree.png'),
      envImg: require('@/assets/site/company_environment.jpg'),
      channelImg: require('@/assets/site/img_promotion_channel.png'),
      personnelList: data.personnelList,
      recruitList: data.recruitList,
      recruitFeature: data.recruitFeature,
      recruitPositions: data.recruitPosition
    };
  },
  created() {
    this.pageResize()

  },
  methods: {
    pageResize() {
      if (document.body.clientWidth > 1440) {
        this.recruitPositions = slicingArray(data.recruitPosition, 999, 3, false)
      } else {
        this.recruitPositions = slicingArray(data.recruitPosition, 3, 3, false)
      }
    },
    toEmail() {
      location.href='mailto:hr@apjcorp.com'
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/theme.scss';

div {
  width: 100%;
}

/** page style */
.overview-introduce {
  height: 500px;
  align-self: flex-start;
  background-image: url('~@/assets/site/aboutus_bg2.jpg')
}
.introduce-container {
  max-width: 1140px;
  padding: 80px;
}

.introduce-container-left {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.title {
  padding: 10px 0 30px;
  font-size: 30px;
  font-weight: bold;
}

.welfare-container {
  padding-bottom: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .welfare-list {
    width: 55%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;

    .welfare-item {
      height: 170px;
      margin: 10px 20px 10px 0;
      display: flex;
      flex-direction: column;
      border: 1px solid $color-border-grey;

      .welfare-title {
        width: 170px;
        height: 50px;
        line-height: 50px;
        padding-left: 50px;
        background-color: $color-bg-primary;
        color: $color-text-white;
        font-weight: bold;
      }
      .welfare-desc {
        padding: 20px 50px;
      }
    }
  }
  .welfare-tree {
    max-width: 462px;
    width: 40%;
    margin-right: 50px;
  }
}

.personnel-container {
  padding-bottom: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .personnel-item {
    // min-height: 330px;
    margin: 0 10px;
    padding: 20px;
    border: 1px solid $color-border-grey;
    display: flex;
    flex-direction: column;

    i {
      font-size: 60px;
      line-height: 80px;
      color: $color-text-primary;
    }

    .personnel-title {
      font-size: 20px;
      margin-bottom: 10px;
      font-weight: bold;
    }
  }
}

.recruit-container {
  margin: 0 0 70px;
  padding: 50px 20px;
  border: 1px solid $color-border-grey;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  .rec-title {
    width: 120px;
    height: 40px;
    top: -20px;
    line-height: 40px;
    border-radius: 40px;
    position: absolute;
    background-color: $color-bg-primary;
    color: $color-text-white;
  }
  .rec-positions {
    padding-bottom: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .rec-position {
       display: grid;
      grid-template-columns: repeat(5, 1fr); /* 第一行5列，每列等宽 */
      grid-template-rows: auto; /* 第二行根据内容自动调整高度 */
      // padding: 0 10%;
      flex-direction: row;
      justify-content: center;

      .rec-position-item {
        display: flex;
        justify-content: center;

        .rec-feacture-name {
          padding: 0 10px;
          color: $color-text-grey;
        }
        .rec-feacture-title {
          font-weight: bold;
        }
      }

    }
  }

  .rec-feactures {
    display: flex;
    flex-direction: row;
    justify-content: center;

    .rec-feacture-name {
      font-size: 14px;
      color: $color-text-primary;
    }
    .rec-feacture-title {
      font-size: 14px;
      padding-right: 20px;
    }
  }

}

.to-recruit-button {
  width: 200px;
  height: 40px;
  margin-top: 30px;
  line-height: 40px;
  border: 1px solid $color-border-primary;
  i {
    margin-left: 10px;
  }
}
.to-recruit-button:hover {
  cursor: pointer;
  background-color: $color-bg-primary;
  span, i {
    color: $color-text-white;
  }
}
// .recruit-container {
//   padding-bottom: 50px;
//   display: flex;
//   flex-direction: row;
//   justify-content: space-between;
//   flex-wrap: wrap;

//   .recruit-item {
//     width: calc(50% - 20px);
//     min-height: 330px;
//     margin: 10px;
//     padding-bottom: 40px;
//     border: 1px solid $color-border-grey;
//     display: flex;
//     flex-direction: column;
//     text-align: left;

//     .recruit-type {
//       width: 150px;
//       height: 40px;
//       line-height: 40px;
//       padding: 0 30px;
//       background-color: $color-bg-primary;
//       color: $color-text-white;
//       font-weight: bold;
//       align-self: flex-end;
//       text-align: center;
//     }

//     .recruit-name {
//       font-size: 20px;
//       font-weight: bold;
//       padding-bottom: 30px;
//       padding: 0 30px;
//     }

//     .recruit-title {
//       font-weight: bold;
//       padding: 5px 30px;
//     }

//     .recruit-desc {
//       padding: 0 30px;
//     }
//   }
// }
</style>



// WEBPACK FOOTER //
// src/views/aboutus/join/index.vue